import { Box } from '@mui/material';

import AuthLayout from '@layouts/authLayout/Auth.layout';
import StaffLogin from '@components/login/staff/login';

const StaffLoginPage = () => {
  return (
    <Box display="flex" width="100%">
      <AuthLayout>
        <StaffLogin />
      </AuthLayout>
    </Box>
  );
};

export default StaffLoginPage;
